import { useContext, useEffect } from "react"
import { Link } from "react-router-dom";
import { NotificationCtx } from "../../context/notificationContext"
import { Button } from "../ui/button"
import { SvgCheckCircle, SvgNotifications } from "../icons/"
import { Badge } from "../ui/badge"
import { ListNotifications } from "../notifications/ListNotifications"
import { Popover, PopoverClose, PopoverContent, PopoverTrigger } from "../ui/popover";

export function NotificationBell() {
    const { hideNotificationAlert } = useContext(NotificationCtx)
    const { notifications, markAllAsRead } = useContext(NotificationCtx)

    useEffect(() => {
        hideNotificationAlert()
    }, [])

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="ghost" size="icon" className="relative"><SvgNotifications />
                    {notifications.filter((n) => !n.viewed).length > 0 && (
                        <Badge dot variant="alert" className="absolute right-1 top-1" />
                    )}
                </Button>
            </PopoverTrigger>
            <PopoverContent
                className="w-[400px] max-h-[500px] overflow-y-auto rounded-lg z-[9999] flex flex-col gap-2"
                align="end"
                sideOffset={20}
            >
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <h3 className="font-bold text-lg flex flex-row gap-2">
                            Notifications
                        </h3>
                        {notifications.filter((n) => !n.viewed).length > 0 && (
                            <Badge variant="alert">
                                {notifications.filter((n) => !n.viewed).length}
                            </Badge>
                        )}
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={markAllAsRead}
                        disabled={!notifications.filter((n) => !n.viewed).length}
                    >
                        <SvgCheckCircle />
                        Mark all as read
                    </Button>
                </div>

                <ListNotifications />

                <PopoverClose asChild>
                    <Button variant="secondary" size="sm" asChild className="w-full p-2">
                        <Link to="/notifications">View all notifications</Link>
                    </Button>
                </PopoverClose>
            </PopoverContent>
        </Popover>
    )
}